import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'lib/auth';
import { Button } from 'components/Elements';
import { Lock, ArrowRight } from 'lucide-react';
import LogoBlack from 'assets/logo-black.png';

export const Landing = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleEnter = () => {
    if (user) navigate('/app');
    else navigate('/auth/login');
  };

  return (
    <div className="min-h-screen bg-[#f4f1ea] text-[#1a1a1a] font-serif flex flex-col">
      {/* TOP STRIP — subtle newspaper feel */}
      <div className="border-b border-black text-xs tracking-wide px-6 py-2 flex justify-between">
        <span>Mukutu Media Editorial System</span>
        <span>{new Date().toDateString()}</span>
      </div>

      {/* MAIN CENTERED LAYOUT */}
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-3xl text-center">
          <div className="flex flex-row items-center justify-center">
            <img src={LogoBlack} alt="mukutu logo" className="h-24" />
          </div>
          <h1 className="text-5xl md:text-6xl font-bold tracking-tight mb-3">MUKUTU MEDIA</h1>

          <p className="uppercase tracking-[0.25em] text-xs text-gray-600 mb-10">
            Editorial Access Portal
          </p>

          {/* DIVIDER */}
          <div className="border-t border-black w-24 mx-auto mb-10"></div>

          {/* ACCESS BOX */}
          <div className="border border-black bg-white p-8 md:p-10 shadow-sm">
            <div className="flex items-center justify-center gap-2 mb-4">
              <Lock className="w-4 h-4" />
              <span className="text-xs uppercase tracking-wider">Restricted Access</span>
            </div>

            <h2 className="text-2xl font-semibold mb-3">Enter the Newsroom</h2>

            <p className="text-sm text-gray-600 mb-8 max-w-md mx-auto">
              This system is reserved for authorized editors, journalists, and administrative staff
              of Mukutu Media.
            </p>

            <Button
              onClick={handleEnter}
              className="px-6 py-2 text-sm flex items-center gap-2 mx-auto"
            >
              {user ? 'Open Dashboard' : 'Login to Continue'}
              <ArrowRight className="w-4 h-4" />
            </Button>

            {/* SUBTEXT */}
            <p className="text-[11px] text-gray-500 mt-6">All access is logged and monitored.</p>
          </div>

          {/* FOOTNOTE STYLE */}
          <p className="text-xs text-gray-500 mt-10">
            © {new Date().getFullYear()} Mukutu Media — Kampala, Uganda
          </p>
        </div>
      </main>
    </div>
  );
};

export default Landing;
